import apiClient from '../lib/apiClient';

const incrementLettersService = {
  // Get all increment letters
  getIncrementLetters: async (filters = {}) => {
    try {
      const result = await apiClient.get('/increment-letters', filters);
      return result;
    } catch (error) {
      return { success: false, error: error.message || 'Failed to fetch increment letters' };
    }
  },

  // Get increment letter by ID
  getIncrementLetter: async (id) => {
    try {
      const result = await apiClient.get(`/increment-letters/${id}`);
      return result;
    } catch (error) {
      return { success: false, error: error.message || 'Failed to fetch increment letter' };
    }
  },

  // Create increment letter
  createIncrementLetter: async (data) => {
    try {
      const result = await apiClient.post('/increment-letters', data);
      return result;
    } catch (error) {
      return { success: false, error: error.message || 'Failed to create increment letter' };
    }
  },

  // Update increment letter
  updateIncrementLetter: async (id, data) => {
    try {
      const result = await apiClient.put(`/increment-letters/${id}`, data);
      return result;
    } catch (error) {
      return { success: false, error: error.message || 'Failed to update increment letter' };
    }
  },

  // Delete increment letter
  deleteIncrementLetter: async (id) => {
    try {
      const result = await apiClient.delete(`/increment-letters/${id}`);
      return result;
    } catch (error) {
      return { success: false, error: error.message || 'Failed to delete increment letter' };
    }
  },

  // Download increment letter as PDF/HTML
  downloadIncrementLetter: async (id) => {
    try {
      const token = localStorage.getItem('erp_auth_token');
      const response = await fetch(`${import.meta.env.VITE_API_URL || `http://${window.location.hostname}:8000`}/api/increment-letters/${id}/download`, {
        method: 'GET',
        headers: {
          'Authorization': `Bearer ${token}`,
        },
      });

      if (!response.ok) {
        throw new Error('Failed to download increment letter');
      }

      const blob = await response.blob();
      const url = window.URL.createObjectURL(blob);
      const a = document.createElement('a');
      a.href = url;
      a.download = `Increment_Letter_${id}.html`;
      document.body.appendChild(a);
      a.click();
      window.URL.revokeObjectURL(url);
      document.body.removeChild(a);

      return { success: true };
    } catch (error) {
      return { success: false, error: error.message || 'Failed to download increment letter' };
    }
  }
};

export default incrementLettersService;

